'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('pdashboard', {
      url: '/pdashboard',
      template: '<pdashboard></pdashboard>'
    });
}



// WEBPACK FOOTER //
// ./client/app/pdashboard/pdashboard.routes.js